import classNames from 'classnames'

interface Props {
    children: string
    unselected?: boolean
}

export function Pill({ children, unselected = false }: Props) {
    return (
        <div
            key={1}
            className={classNames(`flex items-center rounded-full pb-[1px] w-fit px-4 h-7 bg-primary text-white`, { 'opacity-[0.5]': unselected })}
        >
            {children}
        </div>
    )
}
